export const environment = {
    apiURL: 'https://dev.bookingx.in.th/core',
    imgURL: 'https://dev.bookingx.in.th/uploads',
};
